import { create } from 'zustand';

type AppState = {
  darkMode: boolean;
  language: 'en' | 'he';
  direction: 'ltr' | 'rtl';
  toggleDarkMode: () => void;
  setLanguage: (lang: 'en' | 'he') => void;  
};

const useAppStore = create<AppState>((set) => ({
  darkMode: false,
  language: 'he',
  direction: 'rtl',
  toggleDarkMode: () => set((state) => ({ darkMode: !state.darkMode })),
  setLanguage: (lang) => set({ language: lang, direction: lang === 'he' ? 'rtl' : 'ltr' }),
}));

export default useAppStore;
